export const SET_CAROUSEL = "SET_CAROUSEL";
export const GET_CAROUSEL = "GET_CAROUSEL";
export const DELETE_CAROUSEL = "DELETE_CAROUSEL";